import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    "@keyframes rotate": {
      "0%": {
        transform: "rotate(0)",
      },
      "100%": {
        transform: "rotate(360deg)",
      },
    },
    buttonClose: {
      position: "absolute",
      right: 0,
      top: 0,
      marginRight: 2,
      marginTop: 2,
      color: theme.palette.neutral.main,
      background: theme.palette.primary.main,
      transform: "translate(50%, -50%)",
      padding: 4,
      "&:hover": {
        "@media (hover: hover)": {
          color: theme.palette.neutral.main,
          "& svg": {
            animationName: "$rotate",
            animationDirection: "normal",
            animationDuration: "1s",
            animationIterationCount: 1,
          },
        },
      },
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(36),
      },
    },
  }),
  { name: "SpinningCloseButton" },
);
